"use client";

import { type ReactNode } from "react";
import { AlertCircle } from "lucide-react";

import { Button } from "@/shared/ui/buttons/button";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={
        className ?? "flex flex-1 items-center justify-center py-12 text-center"
      }
    >
      <div>
        {icon && <div className="mb-4 flex justify-center">{icon}</div>}
        <h3 className="mb-2 text-lg font-semibold">{title}</h3>
        {description && (
          <p className="mb-4 text-sm text-muted-foreground">{description}</p>
        )}
        {actionLabel && onAction && (
          <Button onClick={onAction} variant="outline" size="sm">
            <AlertCircle className="mr-2 h-4 w-4" aria-hidden />
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
